export default __webpack_public_path__ + "efcabb54b53e4e71b5be7c6aeea2cb24.png";